export const extConfig = {
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: true,
    orderedList: true,
    horizontalRuler: true,
    link: true,
    emote: true,
    deviation: {
        defaultWidth: 430,
        canLink: true
    },
    gallery: {
        defaultWidth: 430,
        defaultAlignment: 'center',
        defaultGridItemWidth: 250,
        defaultGridItemHeight: 200,
        defaultLayout: 'grid',
        defaultTorpedoRowHeight: 200,
        defaultLayoutSpacing: 8,
        canLink: true
    },
    anchor: true,
    blockDragging: false,
    blockquote: true,
    heading: true,
    mention: true,
    paste: true,
    textAlignment: true,
    textColor: true,
    textFont: true,
    textHighlight: true,
    history: true,
    allowUploads: true,
    gif: true,
    indent: {
        captureTab: false
    }
};
export const extConfigFullscreen = {
    bold: true,
    italic: true,
    strikethrough: true,
    underline: true,
    bulletList: true,
    orderedList: true,
    horizontalRuler: true,
    link: true,
    emote: true,
    deviation: {
        defaultWidth: 780
    },
    gallery: {
        defaultWidth: 780,
        defaultAlignment: 'center',
        defaultGridItemWidth: 250,
        defaultGridItemHeight: 200,
        defaultLayout: 'grid',
        defaultTorpedoRowHeight: 200,
        defaultLayoutSpacing: 8
    },
    anchor: true,
    blockDragging: true,
    blockquote: true,
    heading: true,
    mention: true,
    paste: true,
    textAlignment: true,
    textColor: true,
    textFont: true,
    textHighlight: true,
    history: true,
    allowUploads: true,
    gif: true,
    indent: {
        captureTab: true
    }
};

//# sourceMappingURL=config.js.map